import { Directive, Input, Inject } from '@angular/core';
import {
  NG_ASYNC_VALIDATORS,
  AsyncValidator,
  AbstractControl,
  ValidationErrors,
  Validators
} from '@angular/forms';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from '../tokens';
import { Observable, of } from 'rxjs';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Directive({
  selector:
    // tslint:disable-next-line: directive-selector
    '[address][formControlName],[address][formControl],[address][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: AddressValidatorDirective,
      multi: true
    }
  ]
})
export class AddressValidatorDirective implements AsyncValidator {
  @Input() required: boolean = undefined;
  @Input() enabled: boolean = undefined;

  addressValidator: { enabled: boolean; required: boolean; regex: string };

  constructor(
    @Inject(VALIDATORS_CONFIGURATION_TOKEN)
    configuration: ValidatorsConfiguration
  ) {
    this.addressValidator = configuration.address;
  }

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if (this.required === undefined || this.required === null) {
      if (this.addressValidator.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    } else {
      if (this.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    }

    if (this.enabled === undefined || this.enabled === null) {
      if (this.addressValidator.enabled) {
        return control.value.match(new RegExp(this.addressValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    } else {
      if (this.enabled) {
        return control.value.match(new RegExp(this.addressValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    }

    return of(null);
  }
}
